import React, { Component } from "react";

export default class AIChatbox extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const dfMessenger = document.querySelector("df-messenger");
    if (dfMessenger) {
      // dfMessenger.style.setProperty("display", "unset");
      // dfMessenger.style.setProperty("right", this.props.right);
      dfMessenger.startNewSession({ retainHistory: false });
    }
    const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
    if (dfMessengerBubble) {
      dfMessengerBubble.openChat();

      window.addEventListener("df-button-clicked", (event) => {
        var details = event.detail;
        var event = details.event || "";
        var text = details.text || "";
        if (text.includes("ภาษาไทย") && !event) {
          if (!window.sessionStorage.getItem("dfcx_lang_code")) {
            window.sessionStorage.setItem("dfcx_lang_code", "th");
          }
          window.addEventListener("df-request-sent", (event) => {
            event.detail.data.requestBody.queryInput.languageCode = window.sessionStorage.getItem("dfcx_lang_code");
          });
          dfMessenger.renderCustomText(text, false);
          dfMessenger.sendRequest("event", "greeting");
          // setTimeout(() => {
          //   dfMessenger
          //     .querySelector("df-messenger-chat-bubble")
          //     .shadowRoot.querySelector("df-messenger-chat")
          //     .shadowRoot.querySelector("df-messenger-user-input")
          //     .shadowRoot.querySelector(".textarea-wrapper textarea")
          //     .removeAttribute("readonly");
          // }, 200);
        } else if (text.includes("English") && !event) {
          if (!window.sessionStorage.getItem("dfcx_lang_code")) {
            window.sessionStorage.setItem("dfcx_lang_code", "en");
          }
          window.addEventListener("df-request-sent", (event) => {
            event.detail.data.requestBody.queryInput.languageCode = window.sessionStorage.getItem("dfcx_lang_code");
          });
          dfMessenger.renderCustomText(text, false);
          dfMessenger.sendRequest("event", "greeting");
          // setTimeout(() => {
          //   dfMessenger
          //     .querySelector("df-messenger-chat-bubble")
          //     .shadowRoot.querySelector("df-messenger-chat")
          //     .shadowRoot.querySelector("df-messenger-user-input")
          //     .shadowRoot.querySelector(".textarea-wrapper textarea")
          //     .removeAttribute("readonly");
          // }, 200);
        } else {
          if (text && !event) {
            dfMessenger.renderCustomText(text, false);
            dfMessenger.sendRequest("query", text);
          } else if (text && event) {
            dfMessenger.renderCustomText(text, false);
          } else if (!text && !event) {
            dfMessenger.sendRequest("event", "flow-failed");
          }
        }
      });

      if (!window.sessionStorage.getItem("dfcx_lang_code")) {
        // setTimeout(() => {
        //   dfMessenger
        //     .querySelector("df-messenger-chat-bubble")
        //     .shadowRoot.querySelector("df-messenger-chat")
        //     .shadowRoot.querySelector("df-messenger-user-input")
        //     .shadowRoot.querySelector(".textarea-wrapper textarea")
        //     .setAttribute("readonly", true);
        // }, 200);

        const start_selectLang = [
          {
            type: "html",
            html: "<b style='font-size:21px'>เลือกภาษา (Select Language)</b>",
          },
        ];
        dfMessenger.renderCustomCard(start_selectLang);
        const thai_btn = [
          {
            type: "button",
            icon: {
              type: "chevron_right",
              color: "#FF9800",
            },
            mode: "blocking",
            text: "ภาษาไทย",
            // event: {
            //   event: "greeting",
            // },
          },
        ];
        dfMessenger.renderCustomCard(thai_btn);
        const eng_btn = [
          {
            type: "button",
            icon: {
              type: "chevron_right",
              color: "#FF9800",
            },
            mode: "blocking",
            text: "English",
            // event: {
            //   event: "greeting",
            // },
          },
        ];
        dfMessenger.renderCustomCard(eng_btn);
      } else {
        window.addEventListener("df-request-sent", (event) => {
          event.detail.data.requestBody.queryInput.languageCode = window.sessionStorage.getItem("dfcx_lang_code");
        });
        dfMessenger.sendRequest("event", "greeting");
      }
    }
  }

  render() {
    const agent_id = process.env.REACT_APP_DIALOGFLOW_CX_AGENT_ID;
    return (
      <df-messenger project-id="gkrppgz-itonecs-genai" agent-id={agent_id} allow-feedback="all" location="global">
        <df-messenger-chat-bubble
          chat-title="Sandee"
          // chat-subtitle="ปัจจุบันรองรับภาษาอังกฤษเท่านั้น แสนดีกำลังทำงานอย่างหนักเพื่อให้พี่ๆสามารถสนทนากับเราได้เป็นภาษาไทยค่ะ"
          allow-fullscreen="always"
        >
          {" "}
        </df-messenger-chat-bubble>
      </df-messenger>
    );
  }
}
